<template>
  <v2-modal
    :show="show"
    title="Send a message"
    :size="showExpandedView ? 'lg' : 'md'"
    @close="onCancel"
  >
    <div v-if="showForm">
      <div v-show="!showExpandedView">
        <p class="v2-text-sm v2-text-muted v2-mb-3">
          This message will be shared through the platform. Any responses will be processed by our team accordingly
        </p>
        <div class="v2-mb-3">
          <v2-badge variant="default">
            {{ retailerName }}
          </v2-badge>
        </div>
        <v2-input
          :value="subject"
          label="Subject *"
          placeholder="Type in your message subject"
          :error="subject.length > 0 && subject.length < 5 ? 'Subject must be at least 5 characters' : ''"
          @input="subject = $event"
        />
      </div>
      <div
        v-show="showExpandedView"
        class="v2-mb-3"
      >
        <v2-button
          variant="outline"
          size="sm"
          @click="showExpandedView = false"
        >
          Back
        </v2-button>
      </div>
      <div class="v2-mt-3">
        <label class="v2-text-sm v2-font-bold v2-mb-1 v2-block">
          Message <span class="v2-text-destructive">*</span>
        </label>
        <vue-editor
          v-model="message"
          :editor-toolbar="VUE_EDITOR_DEFAULT_EDIT_OPTIONS"
          placeholder="Type in your message"
          :class="showExpandedView ? 'expanded' : ''"
        />
        <small
          v-if="message && hasValidMessage"
          class="v2-text-destructive v2-text-xs"
        >
          Message should be at least 20 characters
        </small>
        <v2-button
          v-show="!showExpandedView"
          variant="ghost"
          size="sm"
          class="v2-mt-1"
          @click="showExpandedView = true"
        >
          Expand
        </v2-button>
      </div>
    </div>
    <template #footer>
      <v2-button
        v-show="!showExpandedView"
        variant="outline"
        @click="onCancel"
      >
        Cancel
      </v2-button>
      <v2-button
        v-show="!showExpandedView"
        :disabled="!validateInput || isLoading"
        :loading="isLoading"
        @click="onSend"
      >
        {{ isLoading ? 'Sending...' : 'Send' }}
      </v2-button>
    </template>
  </v2-modal>
</template>

<script>
import { toRef } from '@vue/composition-api'
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Button from '@/components/v2/V2Button.vue'
import V2Input from '@/components/v2/V2Input.vue'
import V2Badge from '@/components/v2/V2Badge.vue'
import { VueEditor } from 'vue2-editor'
import { VUE_EDITOR_DEFAULT_EDIT_OPTIONS } from '@/constants'
import { useSendWishlistNotification } from '@/composables/useSendWishlistNotification'

export default {
  name: 'V2SendWishlistNotification',
  components: {
 V2Modal, V2Button, V2Input, V2Badge, VueEditor,
},
  props: {
    show: { type: Boolean, default: false },
    retailerName: { type: String, default: '' },
    retailerEmail: { type: String, default: '' },
  },
  setup(props, { emit }) {
    const retailerEmailRef = toRef(props, 'retailerEmail')
    const sn = useSendWishlistNotification(retailerEmailRef)

    return {
      ...sn,
      VUE_EDITOR_DEFAULT_EDIT_OPTIONS,
      onSend() {
        sn.sendBroadcastMessage(() => emit('close'))
      },
      onCancel() {
        sn.cancelNotification(() => emit('close'))
      },
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.resetForm()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-text-muted { color: var(--v2-muted-foreground); }
.v2-text-destructive { color: var(--v2-destructive); }
.v2-block { display: block; }

.expanded {
  min-height: 400px;
}
</style>
